<template>
    <div class="space-y-4">
        <p class="text-sm uppercase tracking-[0.3em] text-gray-500">Article</p>
        <h1
            class="text-4xl md:text-6xl font-semibold tracking-tight text-gray-900"
        >
            {{ post.title }}
        </h1>
    </div>
</template>

<script setup lang="ts">
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'

    interface BlogPostHeroProps {
        post: CMSArticle
    }

    defineProps<BlogPostHeroProps>()
</script>
